<template>
  <div class="content-wrapper" v-if="loadingComplete()">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Ajouter un membre
        <small>Fiche membre</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
        <li class="active">Ajout d'un membre</li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <form role="form">
            <div class="row">
              <div class="col-md-6">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Données administratives</h3>
                  </div>
                  <div class="box-body">
                    <label for="">Sexe</label>
                    <div class="form-group">
                      <label class="radio-inline">
                        <input type="radio" name="membre[sexe]" id="radioMasculin"
                               value="1"
                               v-model="getMember.sexe">
                        Masculin
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="membre[sexe]" id="radioFeminin"
                               value="0"
                               v-model="getMember.sexe"
                        >
                        Féminin
                      </label>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('membre[nom]') }">
                      <label for="nom">Nom</label>
                      <input type="text" class="form-control" id="nom" name="membre[nom]"
                             v-validate="'required'"
                             @blur="checkIfMemberExist()"
                             placeholder="Nom du membre" v-model="getMember.nom">
                      <span v-show="errors.has('membre[nom]')"
                            class="help-block">Le nom est obligatoire</span>
                    </div>
                    <div class="form-group" :class="{'has-error': errors.has('membre[prenom]') }">
                      <label for="prenom">Prénom</label>
                      <input type="text" class="form-control" id="prenom" name="membre[prenom]"
                             v-validate="'required'"
                             @blur="checkIfMemberExist()"
                             placeholder="Prénom du membre" v-model="getMember.prenom">
                      <span v-show="errors.has('membre[prenom]')"
                            class="help-block">Le prénom est obligatoire</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('membre[date_naissance]') }">
                      <label>Date de naissance</label>
                      <div class="input-group date">
                        <div class="input-group-addon">
                          <i class="fa fa-calendar"></i>
                        </div>
                        <masked-input type="text"
                                      v-model="getMember.date_naissance"
                                      v-validate="'required|date_format:DD/MM/YYYY'"
                                      :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                      :guide="true"
                                      :keepCharPositions="true"
                                      :showMask="true"
                                      @blur="checkIfMemberExist()"
                                      name="membre[date_naissance]"
                                      class="form-control pull-right datepicker"
                                      id="datepicker2">
                        </masked-input>
                      </div>
                      <span v-show="errors.has('membre[date_naissance]')"
                            class="help-block">Date incorrecte</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('membre[adresse]') }">
                      <label for="adresse">Adresse</label>
                      <textarea class="form-control"
                                rows="3"
                                name="membre[adresse]"
                                v-model="getMember.adresse"
                                v-validate="'max:255'"
                                placeholder="Adresse du membre...">

                                </textarea>
                      <span v-show="errors.has('membre[adresse]')" class="help-block">L'adresse doit comporter moins de 255 caractères</span>
                    </div>

                    <cp-and-ville
                      :cpProp="this.getMember.cp"
                      :villeProp="this.getMember.ville"
                      :reset="resetCpAndVille"
                      placeholder_cp="Code postal du membre"
                      placeholder_ville="Ville du membre"
                      @villeChanged="setVilleMember"
                      @cpChanged="setcpMember"
                    >
                    </cp-and-ville>

                    <div class="form-group">
                      <label for="ville">Nationalite</label>
                      <select class="form-control" name="membre[nationalite]"
                              v-model="getMember.nationalite">
                        <option value="ZZ">Nationalité
                          indéterminée
                        </option>
                        <optgroup label="Habituels">
                          <option
                            v-for="pays in getPays.habituels"
                            :value="pays.id"
                          >{{ pays.name }}
                          </option>

                        </optgroup>
                        <optgroup label="Autres">
                          <option
                            v-for="pays in getPays.all"
                            :value="pays.id"
                          > {{ pays.name }}
                          </option>
                        </optgroup>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Données de contact</h3>
                  </div>
                  <div class="box-body">
                    <div class="form-group" :class="{'has-error': errors.has('membre[mail]') }">
                      <label for="mail">E-mail</label>
                      <input type="mail" class="form-control" id="email" name="membre[mail]"
                             v-validate="'email'"
                             placeholder="Email du membre"
                             v-model="getMember.mail"
                      >
                      <span v-show="errors.has('membre[mail]')"
                            class="help-block">Adresse mail incorrecte</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('membre[telephone]') }">
                      <label for="telephone">Téléphone</label>
                      <input type="text" class="form-control" id="telephone"
                             name="membre[telephone]"
                             placeholder="Téléphone du membre"
                             v-model="getMember.telephone"
                      >
                      <span v-show="errors.has('membre[telephone]')"
                            class="help-block">Numéro de téléphone incorrect</span>
                    </div>

                    <div class="form-group" :class="{'has-error': errors.has('membre[gsm]') }">
                      <label for="gsm">GSM</label>
                      <input type="text" class="form-control" id="gsm" name="membre[gsm]"
                             placeholder="GSM du membre"
                             v-model="getMember.gsm"
                      >
                      <span v-show="errors.has('membre[gsm]')"
                            class="help-block">Numéro de GSM incorrect</span>
                    </div>

                    <label for="">Affichage public ?</label>
                    <div class="form-group">
                      <label class="radio-inline">
                        <input type="radio" name="membre[affichage_num]" id="radioaucun"
                               value="0"
                               v-model="getMember.affichage_num">
                        Aucun
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="membre[affichage_num]" id="radiotel"
                               value="tel"
                               v-model="getMember.affichage_num"
                        >
                        Téléphone
                      </label>
                      <label class="radio-inline">
                        <input type="radio" name="membre[affichage_num]" id="radiogsm"
                               value="gsm"
                               v-model="getMember.affichage_num"
                        >
                        GSM
                      </label>
                    </div>

                    <div class="form-group" >
                      <label for="adresse">Commentaires</label>
                      <textarea class="form-control"
                                rows="3"
                                name="membre[comment]"
                                v-model="getMember.comment"
                                placeholder="Commentaires éventuels...">
                 </textarea>
                    </div>

                  </div>
                </div>

                <div class="box box-primary">
                  <div class="overlay"
                       v-if="isInputLoading('numlicenceABFT')"
                  >
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>

                  <div class="box-header with-border">
                    <h3 class="box-title">Informations de licence</h3>
                  </div>
                  <div class="box-body">
                    <div class="form-group" v-if="!membreAdministratif"
                         :class="{'has-error': numLicenceExist!=null, 'has-success': numLibre==true && numLicenceExist==null }">
                      <label for="num_kukkiwon">Numéro de licence</label>
                      <div class="input-group">

                        <input type="text" class="form-control" id="num_kukkiwon"
                               name="membre[numlicenceABFT]"
                               @keyup="checkIfNumeroLicenceExist()"
                               placeholder="Numéro de licence du membre"
                               v-model="getMember.numlicenceABFT"
                               disabled
                        >

                        <div class="input-group-btn">
                          <button type="button" class="btn btn-primary btn-flat"
                                  @click="getNewNumeroLicence() ">
                            Obtenir un numéro de licence libre
                          </button>
                        </div>
                      </div>
                      <span v-if="numLicenceExist!=null"
                            class="help-block">Ce numéro est déjà pris par {{ numLicenceExist.fullName }}</span>
                      <span v-if="numLibre==true && numLicenceExist==null"
                            class="help-block">Ce numéro est libre et sera confirmé à la sauvegarde du membre</span>
                    </div>

                    <div class="form-group"
                         :class="{'has-error': errors.has('membre[date_entree]') }">
                      <label>Date d'entrée à l'ABFT</label>
                      <div class="input-group date">
                        <div class="input-group-addon">
                          <i class="fa fa-calendar"></i>
                        </div>
                        <masked-input type="text"
                                      v-model="getMember.date_entree"
                                      name="membre[date_entree]"
                                      v-validate="'date_format:DD/MM/YYYY'"
                                      :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                      :guide="true"
                                      :keepCharPositions="true"
                                      :showMask="true"
                                      class="form-control pull-right datepicker"
                                      id="datepicker2"></masked-input>
                      </div>
                      <span v-show="errors.has('membre[date_entree]')"
                            class="help-block">Date incorrecte</span>
                    </div>

                  </div>
                </div>

                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">
                      Licence
                    </h3>
                    <div class=" pull-right">
                      <label for="MembreAdmin">Membre Administratif ?</label>
                      <input type="checkbox" v-model="membreAdministratif">
                    </div>
                  </div>

                  <div class="box-body" v-if="!membreAdministratif">
                    <div class="row">
                      <div class="col-md-12">
                        <list-select-club
                          :clubsLicenciesUniquement="true"
                          :clubPreSelected="licenceSelected.id_club!=0 ? licenceSelected.id_club : 0"
                          @clubSelected="updateClubSelected"
                        ></list-select-club>

                        <div class="form-group">
                          <label for="recap">
                            Recapitulatif
                          </label>
                          <a v-show="licenceSelected.id_recapitulatif!=0"
                             target="_blank"
                             class="pull-right"
                             href="">
                            Voir le récapitulatif
                          </a>
                          <select class="form-control"
                                  id="recap"
                                  v-model="licenceSelected.id_recapitulatif"
                                  :disabled="disabledSelectRecaps">
                            <option value="0">Aucun</option>
                            <option
                              v-for="recap in recapsFromClub"
                              :value="recap.id"
                            >
                              N°{{ recap.id }} -
                              {{ recap.club.club | uppercase }} -
                              {{ formatDate(recap.created_at, 'DD/MM/YYYY') }}
                            </option>
                          </select>
                        </div>
                        <div class="input-daterange" id="dataRange">
                          <div class="form-group col-md-6">
                            <label>Du:</label>
                            <div class="input-group date ">
                              <div class="input-group-addon">
                                <i class="fa fa-calendar"></i>
                              </div>

                              <masked-input type="text"
                                            v-model="licenceSelected.date_debut"
                                            v-validate="'date_format:DD/MM/YYYY'"
                                            :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                            :guide="true"
                                            :keepCharPositions="true"
                                            :showMask="true"
                                            name="date_debut"
                                            class="form-control pull-right datepicker"
                                            :disabled="disabledSelectRecaps"
                                            id="datepicker5">
                              </masked-input>
                            </div>

                          </div>

                          <div class="form-group col-md-6 ">
                            <label>Au:</label>
                            <div class="input-group date ">
                              <div class="input-group-addon">
                                <i class="fa fa-calendar"></i>
                              </div>
                              <input type="text" name="periodeAu"

                                     v-model="licenceSelected.date_fin"
                                     class="form-control pull-right datepicker"
                                     id="datepicker6">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="typeLicence">Type de licence</label>
                          <select class="form-control"
                                  id="typeLicence"
                                  v-model="licenceSelected.type"
                                  :disabled="disabledSelectRecaps">
                            <option
                              v-for="type in getTypesLicences"
                              :value="type.id"
                            >
                              {{ type.type }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group"
                             :class="{'has-error': errors.has('montant') }">
                          <label for="montant">Montant</label>
                          <div class="input-group">
                            <span class="input-group-addon">€</span>
                            <input type="text"
                                   name="montant"
                                   class="form-control"
                                   id="montant"
                                   v-validate="'required|decimal|min_value:0'"
                                   v-model="licenceSelected.montant"
                                   :disabled="disabledSelectRecaps"
                                   placeholder="">
                          </div>
                          <span v-show="errors.has('montant')"
                                class="help-block">Montant incorrect</span>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>Demande de licence:</label>
                          <div class="radio">
                            <label>
                              <input type="radio"
                                     v-model="licenceSelected.inscription"
                                     name="demandeLicence"
                                     :disabled="disabledSelectRecaps"
                                     id="demandeLicence1" value="1">
                              Reçue
                            </label>
                          </div>
                          <div class="radio">
                            <label>
                              <input type="radio"
                                     v-model="licenceSelected.inscription"
                                     name="demandeLicence"
                                     :disabled="disabledSelectRecaps"
                                     id="demandeLicence2" value="0">
                              Non-reçue
                            </label>
                          </div>
                        </div>

                        <div class="form-group">
                          <label>Payement de licence:</label>
                          <div class="radio">
                            <label>
                              <input type="radio"
                                     v-model="licenceSelected.payement"
                                     name="payementLicence"
                                     :disabled="disabledSelectRecaps"
                                     id="payementLicence1" value="1">
                              Reçue
                            </label>
                          </div>
                          <div class="radio">
                            <label>
                              <input type="radio"
                                     v-model="licenceSelected.payement"
                                     name="payementLicence"
                                     :disabled="disabledSelectRecaps"
                                     id="payementLicence2" value="0">
                              Non-reçue
                            </label>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="medical">Autorisations médicales </label>
                          <div class="checkbox">
                            <label for="apte_pratique">
                              <input id="apte_pratique"
                                     name="apte_pratique"
                                     type="checkbox"
                                     :disabled="disabledSelectRecaps"
                                     v-model="licenceSelected.apte_pratique">
                              Apte à la pratique ?
                            </label>
                          </div>
                          <div class="checkbox">
                            <label for="apte_competition">
                              <input id="apte_competition"
                                     type="checkbox"
                                     name="apte_competition"
                                     :disabled="disabledSelectRecaps"
                                     v-model="licenceSelected.apte_competition">
                              Apte à la compétition ?
                            </label>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="box">
                  <div class="overlay"
                       v-if="this.disabledBtn"
                  >
                    <i class="fa fa-refresh fa-spin"></i>
                  </div>
                  <div class="box-body">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="memberExistCheck"
                      v-show="memberExist"
                      name="checkbox-1"
                      :value="1"
                      :unchecked-value="0"
                      class="pull-right"
                    >
                      Doublon possible détecté. Confirmer l'ajout ?
                    </b-form-checkbox>
                  </div>
                  <div class="box-footer">
                    <button type="button"
                            class="btn btn-lg btn-primary btn-flat margin pull-right"
                            :disabled="errors.count()!=0 || !this.numLibre || this.disabledBtn || this.loadingInputs.length>0 || (memberExist && !memberExistCheck)"
                            @click="sendForm()"
                    >
                      Ajouter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import ListSelectClub from '../../Communs/listeSelectClub'
import cpAndVille from '../../Communs/cpAndVille'

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')
var FileSaver = require('file-saver');

export default {
  data() {
    return {
      villeTemp: null,
      numLicenceExist: null,
      numLibre: true,
      loadingInputs: [],
      disabledBtn: false,
      dataTableLogMember: null,
      dataTableFilesMember: null,
      loadingSecretariatBox: false,
      licenceSelected: {id: 0},
      disabledSelectRecaps: false,
      recapsFromClub: null,
      membreAdministratif: false,
      resetCpAndVille: false,
      memberExist: false,
      memberExistCheck: false,
    }
  },
  computed: {
    ...mapGetters({
      getMember: 'getMember',
      getProfessions: 'getProfessions',
      getPays: 'getPays',
      getRoutes: 'getRoutes',
      getVilles: 'getVilles',
      getRoute: 'getRoute',
      getTypesLicences: 'getTypesLicences',
      getStatutsSportifs: 'getStatutsSportifs',
    }),
  },
  mounted: function () {
    var these = this
    this.$nextTick(function () {

    })
  },
  created() {
    this.checkIfNumeroLicenceExist = _.debounce(this.checkIfNumeroLicenceExist, 300);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setMember(null)
      // console.log("Route Enter Add Member")
      vm.setMember(vm.newMember())
      vm.licenceSelected = vm.newLicence()
      vm.getNewNumeroLicence()
    })
  },
  components: {
    cpAndVille,
    ListSelectClub,
  },
  methods: {
    ...mapActions({
      setMember: 'setMember',
    }),
    loadingComplete: function () {
      return this.getMember != null &&
        this.getPays != null &&
        this.getVilles != null &&
        this.getProfessions != null
    },
    newLicence: function () {
      return {
        id: 0,
        date_debut: moment().format('DD/MM/YYYY'),
        date_fin: moment().add(1, 'years').format('DD/MM/YYYY'),
        id_club: 0,
        id_membre: 0,
        id_recapitulatif: 0,
        id_transfert: 0,
        inscription: 1,
        payement: 1,
        apte_competition: 1,
        apte_pratique: 1,
        locked: 0,
        montant: 40,
        recapitulatif: null,
        type: 1,
      }
    },
    newMember: function () {
      this.resetCpAndVille = !this.resetCpAndVille;
      this.memberExist = false;
      this.memberExistCheck = false;
      return {
        sexe: 1,
        nom: "",
        prenom: "",
        date_naissance: moment().subtract(10, 'years').format('DD/MM/YYYY'),
        adresse: "",
        cp: "",
        ville: "",
        nationalite: "BE",
        mail: "",
        telephone: "",
        gsm: "",
        affichage_num: "gsm",
        num_kukkiwon: "",
        num_gal: "",
        discipline: 0,
        show_in_ranking: 1,
        numlicenceABFT: 0,
        date_entree: moment().format('DD/MM/YYYY'),
        id_statut_sportif: 0,
        comment:""
      }
    },
    constructFormLicence: function () {
      return JSON.stringify({
        "id": this.licenceSelected.id,
        "date_debut": this.licenceSelected.date_debut,
        "date_fin": this.licenceSelected.date_fin,
        "id_club": this.licenceSelected.id_club,
        "type": this.licenceSelected.type,
        "montant": this.licenceSelected.montant,
        "inscription": this.licenceSelected.inscription,
        "payement": this.licenceSelected.payement,
        "apte_pratique": this.licenceSelected.apte_pratique,
        "apte_competition": this.licenceSelected.apte_competition,
        "id_recapitulatif": this.licenceSelected.id_recapitulatif,
        "id_transfert": this.licenceSelected.id_transfert,
        "id_membre": this.licenceSelected.id_membre,
      })
    },
    constructFormMember: function () {
      return JSON.stringify({
        "sexe": this.getMember.sexe,
        "membreAdministratif": this.membreAdministratif,
        "nom": this.getMember.nom,
        "prenom": this.getMember.prenom,
        "date_naissance": this.getMember.date_naissance,
        "adresse": this.getMember.adresse,
        "cp": this.getMember.cp,
        "ville": this.getMember.ville,
        "nationalite": this.getMember.nationalite,
        "mail": this.getMember.mail,
        "telephone": this.getMember.telephone,
        "gsm": this.getMember.gsm,
        "affichage_num": this.getMember.affichage_num,
        "date_entree": this.getMember.date_entree,
        "comment": this.getMember.comment,
      })
    },
    sendForm: function () {
      this.disabledBtn = true;
      let self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.membreAdministratif) {
            this.$http.post(this.getRoute('Secretariat.member.store'), this.constructFormMember()).then(function (response) {
              self.$noty.success("Le membre administratif a bien été ajouté")
              self.disabledBtn = false
              self.setMember(self.newMember())
            }, (response) => {
              self.$noty.error("Erreur dans l'ajout du membre")
              self.disabledBtn = false
            });
          } else {
            this.$http.post(this.getRoute('Secretariat.member.store'), this.constructFormMember()).then(function (response) {
              this.licenceSelected.id_membre = response.body.id
              this.$http.post(this.getRoute('Secretariat.licence.store'), this.constructFormLicence()).then(function (response2) {
                self.$noty.success("Le membre a bien été ajouté")
                self.disabledBtn = false
                self.setMember(self.newMember())
                self.licenceSelected.id_membre = 0;
                self.getNewNumeroLicence();
              }, (response2) => {
                self.$noty.error("Erreur dans l'ajout du membre")
                self.disabledBtn = false
              });
            }, (response) => {
              self.$noty.error("Erreur dans l'ajout du membre")
              self.disabledBtn = false
            });
          }
          return;
        } else {
          self.$noty.error("Certains champs sont erronés/incomplets")
          self.disabledBtn = false
        }
      });
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
//                _.find(this.loadingInputs, function (inputNames) {
//                    return inputNames.id == input;
//                })
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
    getNewNumeroLicence: function () {
      this.addToLoadingInputs('numlicenceABFT')
      this.$http.get(this.getRoute('getNewNumeroLicence')).then((response) => {
        this.getMember.numlicenceABFT = response.body
        this.removeFromLoadingInputs('numlicenceABFT')
      }, (response) => {
      });
    },
    checkIfNumeroLicenceExist: function () {
      this.removeFromLoadingInputs('numlicenceABFT')
      this.addToLoadingInputs('numlicenceABFT')
      var these = this;
      this.$http.post(this.getRoute('checkIfNumeroLicenceExist'), {
        id_membre: these.getMember.id,
        numlicence: these.getMember.numlicenceABFT,
      }, {
        // use before callback
        before(request) {
          // abort previous request, if exists
          if (this.previousRequest) {
            this.previousRequest.abort();
          }
          // set previous request on Vue instance
          this.previousRequest = request;
        }
      }).then((response) => {
        // these.$consoleLog(response.body)
        this.numLicenceExist = _.isEmpty(response.body) ? null : response.body
        this.numLibre = this.numLicenceExist == null ? true : false
        this.removeFromLoadingInputs('numlicenceABFT')
      }, (response) => {
        self.$noty.error("Erreur dans la vérification du numéro de licence")
        this.removeFromLoadingInputs('numlicenceABFT')
      });
    },
    show_select_ville: function () {
      return _.isArray(this.getMember.ville) && this.getMember.ville.length > 1
    },
    villeByCp: function (cp) {
      var result = _.filter(this.getVilles, function (item) {
        return item.cp == cp;
      });
      if (result.length == 0)
        return this.getMember.ville = ""
      if (result.length == 1)
        return this.getMember.ville = result[0].name

      this.getMember.ville = result
    },
    setVilleMember: function (value) {
      this.getMember.ville = value;
    },
    setcpMember: function (value) {
      this.getMember.cp = value;
    },
    updateClubSelected: function (value) {
      var these = this
      this.disabledSelectRecaps = true;
      this.licenceSelected.id_club = value.id
      if (this.licenceSelected && this.licenceSelected.id_club) {
        this.$http.get(this.getRoute('getRecapsForOneClub') + value.id).then((response) => {
          these.recapsFromClub = response.body
          this.disabledSelectRecaps = false;
          this.licenceSelected.id_recapitulatif = _.first(these.recapsFromClub) ? _.first(these.recapsFromClub).id : 0;
        });
      }
    },
    checkIfMemberExist: function () {
      let self = this
      this.memberExist = false
      if (this.getMember.nom && this.getMember.nom != ""
        && this.getMember.prenom && this.getMember.prenom != ""
        && this.getMember.date_naissance && this.getMember.date_naissance != ""
      ) {
        this.$http.post(this.getRoute('checkIfMemberExist'), {
          nom: this.getMember.nom,
          prenom: this.getMember.prenom,
          date_naissance: this.getMember.date_naissance,
        }).then((response) => {
          response.body.forEach(function (item, index) {
            self.memberExist = true
            let string = "<a target='_blank' href='/membre/" + item.id + "'>" + item.fullName + "</a> (n° " + item.numlicenceABFT + ") porte le même nom/prénom/date de naissance";
            self.$noty.warning(string, {
              timeout: 8000,
            })
          })
        });
      }
    },
    formatDate: function (value, fmt) {
      if (value == null) return ''
      fmt = (typeof fmt == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmt
      return moment(value, 'YYYY-MM-DD hh:mm:ss').format(fmt)
    },
  },
  watch: {
    'licenceSelected.date_debut': function (value) {
      // debugger
      this.licenceSelected.date_fin = moment(value, 'DD/MM/YYYY').add(1, 'years').format('DD/MM/YYYY');
    },
    membreAdministratif: function (value) {
      if (value)
        this.getMember.numlicenceABFT = 0
      else {
        this.getNewNumeroLicence();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/AddNewMember.vue